module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-thinking.17e34f93.png";